export const convertPascalObjectKeysToCamelCase = (obj: any) => {
  const newObj: any = {};
  Object.keys(obj).forEach((key) => {
    newObj[convertPascalToCamelCase(key)] = obj[key];
  });
  return newObj;
};

export const convertPascalToCamelCase = (pascalCaseString: string) => {
  // Ensure the input is not empty
  if (!pascalCaseString) {
    return '';
  }

  let camelCaseString = pascalCaseString.charAt(0).toLowerCase();

  let passToEnd = false;
  for (let i = 1; i < pascalCaseString.length; i++) {
    const currentChar = pascalCaseString.charAt(i);
    if (passToEnd || i == pascalCaseString.length - 1) {
      camelCaseString += currentChar;
      continue;
    }

    const nextChar = pascalCaseString.charAt(i + 1);
    if (
      currentChar === currentChar.toUpperCase() &&
      nextChar === nextChar.toUpperCase()
    ) {
      camelCaseString += currentChar.toLowerCase();
    } else {
      camelCaseString += currentChar;
      passToEnd = true;
    }
  }

  return camelCaseString;
};
